"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PLUGINS = void 0;
const patched_browser_plugin_button_click_tracking_1 = require("@angi/patched-browser-plugin-button-click-tracking");
const browser_plugin_client_hints_1 = require("@snowplow/browser-plugin-client-hints");
const browser_plugin_enhanced_consent_1 = require("@snowplow/browser-plugin-enhanced-consent");
const browser_plugin_link_click_tracking_1 = require("@snowplow/browser-plugin-link-click-tracking");
const browser_plugin_ga_cookies_1 = require("@snowplow/browser-plugin-ga-cookies");
const browser_plugin_site_tracking_1 = require("@snowplow/browser-plugin-site-tracking");
const browser_plugin_web_vitals_1 = require("@snowplow/browser-plugin-web-vitals");
const browser_plugin_media_1 = require("@snowplow/browser-plugin-media");
const customEnableConfigurations_1 = require("./customEnableConfigurations");
/**
 * Map of the Default Plugins for the Snowplow Web Tracker
 * These will be included in the tracker unless disabled by the user
 */
exports.DEFAULT_PLUGINS = {
    activityTracking: {
        enabled: true,
        enablePlugin: customEnableConfigurations_1.enableActivityTrackingWithConfig,
    },
    buttonClickTracking: {
        enabled: true,
        plugin: patched_browser_plugin_button_click_tracking_1.ButtonClickTrackingPlugin,
        enablePlugin: patched_browser_plugin_button_click_tracking_1.enableButtonClickTracking,
    },
    clientHints: {
        enabled: true,
        plugin: browser_plugin_client_hints_1.ClientHintsPlugin,
    },
    enhancedConsent: {
        enabled: true,
        plugin: browser_plugin_enhanced_consent_1.EnhancedConsentPlugin,
    },
    gaCookies: {
        enabled: true,
        plugin: browser_plugin_ga_cookies_1.GaCookiesPlugin,
    },
    linkClickTracking: {
        enabled: true,
        plugin: browser_plugin_link_click_tracking_1.LinkClickTrackingPlugin,
        enablePlugin: browser_plugin_link_click_tracking_1.enableLinkClickTracking,
        enableConfiguration: {
            pseudoClicks: true,
            trackContent: true,
        },
    },
    siteTracking: {
        enabled: true,
        plugin: browser_plugin_site_tracking_1.SiteTrackingPlugin,
    },
    webVitals: {
        enabled: true,
        plugin: browser_plugin_web_vitals_1.WebVitalsPlugin,
    },
    mediaTracking: {
        enabled: true,
        plugin: browser_plugin_media_1.SnowplowMediaPlugin,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3BsdWdpbnMvY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHFIQUc0RDtBQUM1RCx1RkFBMEU7QUFDMUUsK0ZBQWtGO0FBQ2xGLHFHQUdzRDtBQUN0RCxtRkFBc0U7QUFDdEUseUZBQTRFO0FBQzVFLG1GQUFzRTtBQUN0RSx5RUFBcUU7QUFDckUsNkVBQWdGO0FBR2hGOzs7R0FHRztBQUNVLFFBQUEsZUFBZSxHQUFtQjtJQUMzQyxnQkFBZ0IsRUFBRTtRQUNkLE9BQU8sRUFBRSxJQUFJO1FBQ2IsWUFBWSxFQUFFLDZEQUFnQztLQUNqRDtJQUNELG1CQUFtQixFQUFFO1FBQ2pCLE9BQU8sRUFBRSxJQUFJO1FBQ2IsTUFBTSxFQUFFLHdFQUF5QjtRQUNqQyxZQUFZLEVBQUUsd0VBQXlCO0tBQzFDO0lBQ0QsV0FBVyxFQUFFO1FBQ1QsT0FBTyxFQUFFLElBQUk7UUFDYixNQUFNLEVBQUUsK0NBQWlCO0tBQzVCO0lBQ0QsZUFBZSxFQUFFO1FBQ2IsT0FBTyxFQUFFLElBQUk7UUFDYixNQUFNLEVBQUUsdURBQXFCO0tBQ2hDO0lBQ0QsU0FBUyxFQUFFO1FBQ1AsT0FBTyxFQUFFLElBQUk7UUFDYixNQUFNLEVBQUUsMkNBQWU7S0FDMUI7SUFDRCxpQkFBaUIsRUFBRTtRQUNmLE9BQU8sRUFBRSxJQUFJO1FBQ2IsTUFBTSxFQUFFLDREQUF1QjtRQUMvQixZQUFZLEVBQUUsNERBQXVCO1FBQ3JDLG1CQUFtQixFQUFFO1lBQ2pCLFlBQVksRUFBRSxJQUFJO1lBQ2xCLFlBQVksRUFBRSxJQUFJO1NBQ3JCO0tBQ0o7SUFDRCxZQUFZLEVBQUU7UUFDVixPQUFPLEVBQUUsSUFBSTtRQUNiLE1BQU0sRUFBRSxpREFBa0I7S0FDN0I7SUFDRCxTQUFTLEVBQUU7UUFDUCxPQUFPLEVBQUUsSUFBSTtRQUNiLE1BQU0sRUFBRSwyQ0FBZTtLQUMxQjtJQUNELGFBQWEsRUFBRTtRQUNYLE9BQU8sRUFBRSxJQUFJO1FBQ2IsTUFBTSxFQUFFLDBDQUFtQjtLQUM5QjtDQUNKLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../src/plugins/constants.ts